import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { DeviationViewMode } from '@wix/da-react-context/pkg/SessionContext';
export const loadDeviation = createAction(`${actionKey}.LOAD_DEVIATION`, (deviation)=>({
        deviation
    }));
export const initDeviationPage = createAction(`${actionKey}.INIT_DEVIATION`, (deviation, comments, biMetadata, gruser)=>({
        deviation,
        comments,
        biMetadata,
        gruser
    }));
export const enterZoomMode = createAction(`${actionKey}.ZOOM_ENTER`, (deviation)=>({
        deviation
    }));
export const exitZoomMode = createAction(`${actionKey}.ZOOM_EXIT`, (deviation)=>({
        deviation
    }));
export const fullscreenEntered = createAction(`${actionKey}.VIEW.FULLSCREEN_ENTERED`, (deviation)=>({
        deviation
    }));
export const fullscreenExited = createAction(`${actionKey}.VIEW.FULLSCREEN_EXITED`, (deviation)=>({
        deviation
    }));
export const togglePanel = createAction(`${actionKey}.PANEL_TOGGLE`, (panelType, actionBar)=>({
        panelType,
        actionBar
    }));
export const showPanel = createAction(`${actionKey}.PANEL_SHOW`, (panelType, actionBar)=>({
        panelType,
        actionBar
    }));
export const hidePanel = createAction(`${actionKey}.PANEL_HIDE`, (panelType)=>({
        panelType
    }));
export const hidePanelPopup = createAction(`${actionKey}.PANEL_POPUP.HIDE`, ()=>({}));
export const requestChangeViewMode = createAction(`${actionKey}.VIEW.REQUEST_CHANGE_VIEW_MODE`, (viewMode, deviation)=>({
        viewMode,
        deviation
    }));
export const requestToggleTheaterView = (deviation)=>requestChangeViewMode(DeviationViewMode.Theater, deviation);
export const requestToggleFullscreenView = (deviation)=>requestChangeViewMode(DeviationViewMode.Fullscreen, deviation);
export const setScreenSize = createAction(`${actionKey}.VIEW.SET_SCREEN_SIZE`, (width, height)=>({
        width,
        height
    }));
export const expandAndFocusCommentPanel = createAction(`${actionKey}.EXPAND_AND_FOCUS_COMMENT_PANEL`, (deviation, actionBarType)=>({
        deviation,
        actionBarType
    }));
export const setDeviationGruser = createAction(`${actionKey}.GRUSER.SET`, (deviationId, gruser)=>({
        deviationId,
        gruser
    }));
